import type { LicenseEntitlementBooleanKey } from '#layers/license/types/license';

const HAS_PLURAL_TITLE: Record<LicenseEntitlementBooleanKey, boolean> = {
	sso_enabled: false,
	audit_logs_enabled: true,
	custom_permission_rules_enabled: true,
	offline_enabled: false,
	production_enabled: false,
	telemetry_required: false,
	premium_connectors_enabled: true,
	custom_connectors_enabled: true,
};

export function entitlementGateTitleKey(key: LicenseEntitlementBooleanKey): string {
	return HAS_PLURAL_TITLE[key] ? 'license.gate.title_plural' : 'license.gate.title';
}
